var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.5,58.92H7.5a2,2,0,0,1-2-2V46.64a2,2,0,0,1,2-2h6.11a2,2,0,0,1,0,4H9.5v6.28h45V48.64H24.86a2,2,0,0,1,0-4H56.5a2,2,0,0,1,2,2V56.92A2,2,0,0,1,56.5,58.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30,42.18a18.55,18.55,0,1,1,18-23.1l1.18-1.3a2,2,0,0,1,3,2.69L48,25a2,2,0,0,1-3.48-1.34A14.56,14.56,0,1,0,30,38.18a14.41,14.41,0,0,0,10.45-4.43,2,2,0,0,1,2.88,2.78A18.38,18.38,0,0,1,30,42.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.51,25.63a2,2,0,0,1-.91-.22L40.9,23a2,2,0,1,1,1.83-3.56l4.69,2.41a2,2,0,0,1-.91,3.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.abb7ca12d30e2b540a92e37cae45fe6c.svg";
export { ForwardRef as ReactComponent };